import { default as NextLink } from 'next/link'

import { Link, Stack } from '@mui/material'

import type { FC, ReactNode } from 'react'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import type { ParagraphLink } from '@/gen/sanity/schema'

interface SanityParagraphLinkProps {
  portableTextImageProps: PortableTextTypeComponentProps<ParagraphLink>
  linkIcon?: ReactNode
}

export const SanityParagraphLink: FC<SanityParagraphLinkProps> = ({ portableTextImageProps, linkIcon }) => {
  const paragraphLink = portableTextImageProps.value
  const linkName = paragraphLink?.name
  const url = (paragraphLink && paragraphLink?.url) || '#'
  const target = url && url?.startsWith('http') ? '_blank' : '_self'

  return (
    <Stack component="span" direction="row" spacing={1} alignItems="center">
      {linkIcon}
      <Link component={NextLink} href={url} target={target} rel="noreferrer">
        {linkName}
      </Link>
    </Stack>
  )
}
